export const programEntries = {

    2022: ["Zrušení senátu", "Zrušení posranecké sněmovny", "Zrušení gravitace", "Vystoupení z EU", "Vystoupení z V4", "Vystoupení z NATO", "Vystoupení z r/2visegrad4you", "Zavedení trestní odpovědnosti pro Smrt", "Celkové zrušení smrti", "Podpora Evropské unie ve zrušení českého jazyku", "Zavedení minimálního smrtelného záření pro mikrovlnky", "Boj proti socialismu", "Podpora ANO a SPD ve zrušení demokracie", "Odkolonizování země", "Popravy extrovertů", "Náboženství On-line", "Odnětí svobody za psychické nemoci (Zvláště pak schizofrenie)"],



    2023: ["ČR bude jediná země v EU a NATO", "Uděláme z visegrádské čtyřky visegrádskou jedničku", "Vývoj atomové zbraně velký krtkus", "Připojení Královce, Slezska, Slovenska, Lužického Srbska a Podkarpatské Rusi k ČR", "Zrušení gravitace (stále)", "Zrušení České republiky", "Převelení celé armády do world of tanks", "Zavést odstup 2 metry již napořád", "Szuszený czeskí gramatyki", "Domácí vězení pro krajně pravicové politiky v mešitě", "Zavedení jemného domácího produktu", "Výměna vody z kohoutku za pivo z kohoutku díky výstavbě beer streem 1", "Zestátní výrobců plotů", "Genocida generace alfa", "Dotování české reprezentace v potápění do fazolí", "Maximální počet wattů v elektronice: 1"],



    2024: ["Asocializace České republiky", "Zrušení gravitace", "Pokus konkurovat iluminátům v soukromém sektoru založením tajné aspolečnosti.", "Rozmnožování dinosaurů v českých ZOO, a pomocí mikrovlnek vytvoření napůl železných, napůl živých dinosauřích zbraní hromadného ničení.", "Povolení ještě nenarozeným dětem vraždit své matky. Ať se děti při potratu mohou bránit.", "Vytopení Rakouska.", "Nasazení Českého lva do maid oblečku.", "Znovuobnovení purismu. (Např. Femboy = ženoch, Cringe = poklonkování, operační systém = používací řád)", "Donucení Blanických rytířů platit nájem.", "Legalizace jakýchkoli drog co mohou člověka zabít.", "Vyhlášení války mrtkům", "Vyhlášení státního svátku na narozeniny Járy Cimrmana", "Přejmenování minimálně je jedné ulice v každém městě na ulici Járy Cimrmana", "Navrácení tradičního života v jeskyni a žraní šutrů.", "Sleva na cigarety pro lidi s rakovinou plic.", "Dokončení Benešovského odsouvání odsunutím naprosto všech.", "Vrácení hlavního města do Levého Hradce", "Dožít se roku 2025", 'Vánočního kapra změnit na vánoční kuře z kuchařky Jiřího Babici "Ich bin ein gamer".', "Zavedení manželství pro nikoho."],



    2025: ["Snížit ministerstvo na jedno – ministerstvo předstírání práce.", "O nových zákonech by rozhodovala hra v člověče nezlob se.", "Manželství pouze pro jednu osobu.", "Povolit všechny drogy.", "Řešení bytové krize žitím v jeskyních.", "Podpora ekonomické recese, protože sranda musí být.", "Převedeme hlavní město zpět do Levého Hradce.", "Zrušíme hlavní město.", "Digitalizujeme stát. Úřad bude discord server, stavební řízení přes minecraft.", "Snížit počet krajů na jeden - Liberecký.", "Snížení počtu obcí na jednu.", "Každá budova bude svoje vlastní obec.", "Zrušíme stáří.", 'Přejmenujeme všechny ulice na "Cimrmanova".', "Peníze budou zdarma.", "Zrušíme gravitaci.", "Dobytí Slovenska, Podkarpadské rusi, Lužického srbska, Královce, Slezska, Jiříkova, Grónska a Dalmácie.", "Každou válku vyřešíme hodem mincí.", "Pivo poteče z kohoutků.", "Znělka z kouzelné školky jako státní hymna."],



    2026: ["Snížit počet senátorů na 67.", "Řešit volební program.", "Navrátíme klimatickou krizi.", "Pošleme děti do bitcoinových dolů v Turově.", "Podpora agentů KGB a GRU (potřebujeme porazit Petra Cibulku).", "Zavedeme groše jako měnu.", "Budeme podporovat ekonomickou recesi, protože sranda musí být.", "Přijmeme co nejvíce migrantů, hlavně zločinců, aby se lidé báli chodit ven (absolutní asocializace).", "Zrušíme pravopis, posílíme svobodu slova.", "Zregulujeme věk dožití na 31 let (po třicítce jsme všichni chodící mrtvoly + 31 je turecký symbol pro masturbaci).", "Jsme pro migraci, protože nám migranti seberou p#áci a my nebudeme muset p#acovat.", "Necháme vyvinout nové druhy zvířat, abychom je mohli nechat vyhynout.", "Uděláme revizi státních znaků.", "Změníme hlavní město na Aš, ať jsme co nejdál od Zlováků.", "Vyměníme Kundu za Havířov, tím získáme přístup k moři. #ceskojevkunde", "Snížíme počet názorů na 4.", "Uděláme asociální síť Ř.", "Napadneme Vatikán kvůli nerostným surovinám.", "Osvobodíme Moravu od krutovlády Slezska.", "Osvobodíme Slezsko od krutovlády Moravy."]

};



export const kandidatiKomunalni = {
    "2022": {
        "Jihočeský": {
            "Báňovice": [],
            "České Budějovice": [
                {
                    "jmeno": "Karel Infeld Prácheňský",
                    "csa": true,
                    "info": "herec"
                }
            ],
            "Písek": [
                {
                    "jmeno": "Písek",
                    "csa": true,
                    "info": "chrrsss (prostě zvuky písku)"
                }
            ],
            "Veselí nad Lužnicí": []
        },
        "Jihomoravský": {
            "Brno": [
                {
                    "jmeno": "Desetikoruna",
                    "csa": true,
                    "info": "je na ni vyobrazena neznámá vesnice"
                }
            ],
            "Ořechov u Brna": [
                {
                    "jmeno": "Vlašský Ořech",
                    "csa": true,
                    "info": "kandidát na starostu"
                }
            ],
            "Znojmo": []
        },
        "Karlovarský": {},
        "Královéhradecky": {
            "Jičín": [
                {
                    "jmeno": "Jakub Baševi z Treuenburka",
                    "csa": true,
                    "info": "znamý také jako Trautenberk"
                }
            ],
            "Kramolna": [],
            "Týniště nad Orlicí": [
                {
                    "jmeno": "Strom na kterého chudáka dali vyřezaného příbuzného",
                    "csa": true,
                    "info": ""
                }
            ]
        },
        "Liberecký": {
            "Bratislavice nad Hnisou": [
                {
                    "jmeno": "Konrád Koulemastník",
                    "csa": true,
                    "info": "infulencer a grafik"
                },
                {
                    "jmeno": "pepa troska",
                    "csa": true,
                    "info": "zbyečný stařec"
                }
            ],
            "Česká Lípa": [],
            "Liberec": [
                {
                    "jmeno": "Bodypillow",
                    "csa": true,
                    "info": "objímací polštář Zuzany"
                },
                {
                    "jmeno": "Karel Hrubián",
                    "csa": true,
                    "info": "člověk s krizí existence"
                },
                {
                    "jmeno": "Zuzana Krupicová",
                    "csa": true,
                    "info": "weeb a jediná žena v týmu"
                }
            ],
            "Turnov": [
                {
                    "jmeno": "Pivo Rohozec",
                    "csa": true,
                    "info": "C-tier pivo dle průzkumu ČSA 2022"
                }
            ]
        },
        "Moravskoslezský": {
            "Karviná": [
                {
                    "jmeno": "Mrak",
                    "csa": true,
                    "info": "50 % z hnědého výpary uhlí, 50 % duše havířů"
                }
            ],
            "Orlová": [
                {
                    "jmeno": "Zbožňus",
                    "csa": true,
                    "info": "mnich z místního kláštera"
                }
            ],
            "Ostrava": [
                {
                    "jmeno": "Tomáš Kowalski",
                    "csa": true,
                    "info": "obyvatel Ostravy"
                },
                {
                    "jmeno": "Ostravský Smog",
                    "csa": true,
                    "info": "ten co tě všude sleduje"
                }
            ],
            "Rýmařov": []
        },
        "Olomoucký": {
            "Dub nad Moravou": []
        },
        "Pardubický": {},
        "Plzeňský": {
            "Klatovy": [],
            "Plzeň": [
                {
                    "jmeno": "Honza Novák",
                    "csa": true,
                    "info": "průměrný Čecháček"
                }
            ]
        },
        "Praha": {
            "Praha": [
                {
                    "jmeno": "Felix",
                    "csa": true,
                    "info": "průměrný obyvatel Prahy a kandidát na primátora"
                },
                {
                    "jmeno": "Václav Svoboda",
                    "csa": true,
                    "info": "odpůrce lidí"
                }
            ]
        },
        "Středočeský": {
            "Benátky nad Jizerou": [],
            "Benešov": [],
            "Dobřichovice": [
                {
                    "jmeno": "Černoch z Černošic (ty přejmenujeme na Bělošice)",
                    "csa": true,
                    "info": ""
                }
            ],
            "Hostivice": [],
            "Jílové u Prahy": [],
            "Loděnice": [
                {
                    "jmeno": "Křišťan Krejčí",
                    "csa": true,
                    "info": "jediný Křišťan v ČR"
                },
                {
                    "jmeno": "Jana Jánská",
                    "csa": true,
                    "info": "žena"
                }
            ],
            "Mladá Boleslav": [
                {
                    "jmeno": "Adam Hejtkowitz",
                    "csa": true,
                    "info": "roznašeč letáků"
                },
                {
                    "jmeno": "Vojtěch Adam",
                    "csa": true,
                    "info": "debil"
                },
                {
                    "jmeno": "Míša Kolečko",
                    "csa": true,
                    "info": "duch, městská legenda, dříve zaměstnanec u Černé sanitky"
                },
                {
                    "jmeno": "Prokleté Sluníčko",
                    "csa": true,
                    "info": "noční můra a tvůj nejlepší kamarád při spánkové paralýze"
                },
                {
                    "jmeno": "Škoda 120",
                    "csa": true,
                    "info": "auto"
                }
            ],
            "Pečky": [],
            "Pičín": [],
            "Příbram": [
                {
                    "jmeno": "Jiří Křížek",
                    "csa": true,
                    "info": "křižák"
                }
            ],
            "Vlašim": []
        },
        "Ústecký": {
            "Litvínov": [],
            "Roudnici nad Labem": [
                {
                    "jmeno": "Karel Bystrý",
                    "csa": true,
                    "info": "kandidát na starostu a nenáviděč Ústí nad Labem"
                },
                {
                    "jmeno": "Vojtěch Rouda",
                    "csa": true,
                    "info": "bývalý řidič kamionu a fanoušek lega"
                }
            ],
            "Ústí nad Labem": [
                {
                    "jmeno": "Deprese",
                    "csa": true,
                    "info": "jedna ze tří věcí, co dostaneš v Ústí"
                },
                {
                    "jmeno": "Radim Troska",
                    "csa": true,
                    "info": "závislák na piku již desátým rokem"
                }
            ],
            "Vroutek": [
                {
                    "jmeno": "Heřman Černín z Chudenic",
                    "csa": true,
                    "info": "heřmánkový černoch, co je chudý"
                }
            ]
        },
        "Vysočina": {
            "Vystrkov": []
        },
        "Zlínský": {
            "Zlín": [],
            "Želechovice nad Dřevěnicí": []
        },
        "Slovensko": {
            "Fekišovice": [
                {
                    "jmeno": "Nejvyspělejší obyvatelstvo Slovenska",
                    "csa": true,
                    "info": "asi 308 obyvatel"
                }
            ]
        }
    },
    "2023": {},
    "2024": {},
    "2025": {},
    "2026": {
        "Jihočeský": {
            "Prachatice": {
                "hlasy": 97,
                "procenta": 0.11,
                "kandidati": [
                    {
                        "jmeno": "Jan Pešek",
                        "cislo": 1,
                        "csa": true,
                        "info": "Strojař, Prodej halucinogenů dětem",
                        "hlasy": 97
                    }
                ]
            },
            "Sezimovo Ústí": {
                "hlasy": 102,
                "procenta": 0.2,
                "kandidati": [
                    {
                        "jmeno": "Daniel Skalka",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "Zdravím, lide Sezimácký, já jsem Buglej Děda, sám sebou vyvolený zachránce lidu sezimáckého před zlým Táborem",
                            "Student MUNI, profesionální asociál, fotograf, expert na Instagram Reels, člen Českého svazu tanečního sportu, absolvent Dobrovolného vojenského cvičení 2025, člen redakce školního časopisu GPdC, držitel zvláštní ceny Talentu roku 2025 města Tábora v Humanitní kategorii II., předseda volební komise - Volby do PS 2025, spoludržitel ocenění za 2. místo v soutěži Školní časopis roku 2025 Jihočeského kraje za časopis Makovec GPdC",
                            "Donutím Tábor zaplatit reparace za vypálení Sezimáku v roce 1420",
                            " Zlepším dopravu ve městě lokálním zrušením gravitace",
                            "Návrátím oblíbenou rodinnou zábavu z časů minulých - veřejné popravy",
                            "Na COPku přidám nové opory - Vařič drog a Pouliční dealer",
                            "Dám rozpočet města na červenou"
                        ],
                        "hlasy": 58
                    },
                    {
                        "jmeno": "Julian Alberts",
                        "cislo": 2,
                        "csa": false,
                        "info": [
                            "student",
                            "Ahoj, jsem Julian, lidi mi říkají džulík. Jsem unemployed. Pro lidi co neumí Anglicky, znamená to, že velice rád pracuji. Narodil jsem se v Albertu, jak už napovídá moje příjmení. Nemám rád lidi, mezi mé koníčky patří existování co nejdále od nich, například na vysílačích a obecně na vysokých místech. Do budoucnosti plánuji pokračovat v tom, co dělám teď."
                        ],
                        "hlasy": 44
                    }
                ]
            }
        },
        "Jihomoravský": {
            "Šaratice": {
                "hlasy": 9,
                "procenta": 0.2,
                "kandidati": [
                    {
                        "jmeno": "Adam Kilian",
                        "cislo": 1,
                        "csa": false,
                        "info": "oficiálně nezaměstnaný",
                        "hlasy": 9
                    }
                ]
            }
        },
        "Liberecký": {
            "Dlouhý Most": {
                "hlasy": 28,
                "procenta": 0.78,
                "kandidati": [
                    {
                        "jmeno": "Adam Bouzek",
                        "cislo": 1,
                        "csa": false,
                        "info": [
                            "Full time gambler",
                            "investor do rizikových aktivit",
                            "Pivo v Loterii pro všechny. Femboy centrum místo obecních bytů."
                        ],
                        "hlasy": 28
                    }
                ]
            },
            "Jilemnice": {
                "hlasy": 115,
                "procenta": 0.43,
                "kandidati": [
                    {
                        "jmeno": "Jan Prokeš",
                        "cislo": 1,
                        "csa": true,
                        "info": "Student, instruktor",
                        "hlasy": 76
                    },
                    {
                        "jmeno": "Svatoslav Antonín Selucký",
                        "cislo": 2,
                        "csa": true,
                        "info": "student",
                        "hlasy": 79
                    }
                ]
            },
            "Liberec": {
                "hlasy": 603,
                "procenta": 0.05,
                "kandidati": [
                    {
                        "jmeno": "Kryštof Kolomazník",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "Poradce J. Epsteina",
                            "Jmenuji se Kryštof Kolomazník, ale všichni mi říkají Konrád. I vy mi říkejte Konrád. Moje politika je založena na nenávisti. Nenávidím seniory, protože nepracují, nenávidím děti, protože nepracují. Nesnáším všechny, co vydělávají více než já, protože si to nezaslouží a nesnáším všechny, co vydělávají méně, protože to jsou socky a budou mě chtít okrást. Nesnáším černý, nesnáším bílý a nesnáším i kohokoli mezi tím. Nemám rád teplý lidi, i když jsem sám teplej. Nemám rád policisty, soudce, prodavačky v obchodě ani státního zástupce, dokud od nich něco nepotřebuju a pokud mi odmítnou pomoct, žijeme v diktatuře. Nemám rád, když mi stát kecá do života, ale nemám ani rád, když kvůli absenci regulací musím pracovat za podminimální mzdu na banánových plantážích v Mikulově. Chci prostě jen klid, chládek, pivo (hodně piva) a dostatek elektřiny, aby v televizi mohli dávat fotbal a zprávy a já si měl nad čím zanadávat. Narodil jsem se v Liberci - Vratislavicích nad Nisou, odkud jsem tento rok hrdě emigroval na příštích 5 let do Brna kvůli vysoké škole, kde studuju žurnalistiku, abych se mohl nechat podplácet AIPACem a mít pasivní příjem z psaní pochvalných semipropagandistických článků na INFO.CZ a DeníkTO. Byl jsem předseda České strany asociálů, jsem jejím čestným předsedou, což ze mě dělá člověka, co je alespoň tolik cool, jako Filip Turek. Jen nemám peníze na házení jogurtů na hrady. Chtěl bych bejt línej a u toho okrádat stát poslaneckým platem, ale vím, že jsem ještě mladý a do této pozice se člověk musí dopracovat. "
                        ],
                        "hlasy": 187
                    },
                    {
                        "jmeno": "Pavel Hrubeš",
                        "cislo": 2,
                        "csa": true,
                        "info": [
                            "zklamání",
                            "Moje celá osobnost je založená na shitpostu a posílání koček.",
                            "Na internetu vystupuji pod pseudonymem Karel Hrubián, takže mi všichni říkaj Kája.",
                            "Mým velkým snem jsou samostatné Vratislavice nad Nisou.",
                            "Chci ukončit dlouholetou válku mezi Libercem a Jabloncem nad Nisou. Netuším jak, ale udělám to!"
                        ],
                        "hlasy": 149
                    },
                    {
                        "jmeno": "Veronika Kolomazníková",
                        "cislo": 3,
                        "csa": false,
                        "info": [
                            "Dozorčí orgán.",
                            "Okrádám chudé."
                        ],
                        "hlasy": 136
                    },
                    {
                        "jmeno": "David Kolomazník",
                        "cislo": 4,
                        "csa": false,
                        "info": [
                            "Podřízený dozorčímu orgánu.",
                            "Okrádám bohaté."
                        ],
                        "hlasy": 131
                    }
                ]
            },
            "Liberec–Vratislavice nad Nisou": {
                "hlasy": 142,
                "procenta": 0.33,
                "kandidati": [
                    {
                        "jmeno": "Kryštof Kolomazník",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "Poradce J. Epsteina",
                            "Jmenuji se Kryštof Kolomazník, ale všichni mi říkají Konrád. I vy mi říkejte Konrád. Moje politika je založena na nenávisti. Nenávidím seniory, protože nepracují, nenávidím děti, protože nepracují. Nesnáším všechny, co vydělávají více než já, protože si to nezaslouží a nesnáším všechny, co vydělávají méně, protože to jsou socky a budou mě chtít okrást. Nesnáším černý, nesnáším bílý a nesnáším i kohokoli mezi tím. Nemám rád teplý lidi, i když jsem sám teplej. Nemám rád policisty, soudce, prodavačky v obchodě ani státního zástupce, dokud od nich něco nepotřebuju a pokud mi odmítnou pomoct, žijeme v diktatuře. Nemám rád, když mi stát kecá do života, ale nemám ani rád, když kvůli absenci regulací musím pracovat za podminimální mzdu na banánových plantážích v Mikulově. Chci prostě jen klid, chládek, pivo (hodně piva) a dostatek elektřiny, aby v televizi mohli dávat fotbal a zprávy a já si měl nad čím zanadávat. Narodil jsem se v Liberci - Vratislavicích nad Nisou, odkud jsem tento rok hrdě emigroval na příštích 5 let do Brna kvůli vysoké škole, kde studuju žurnalistiku, abych se mohl nechat podplácet AIPACem a mít pasivní příjem z psaní pochvalných semipropagandistických článků na INFO.CZ a DeníkTO. Byl jsem předseda České strany asociálů, jsem jejím čestným předsedou, což ze mě dělá člověka, co je alespoň tolik cool, jako Filip Turek. Jen nemám peníze na házení jogurtů na hrady. Chtěl bych bejt línej a u toho okrádat stát poslaneckým platem, ale vím, že jsem ještě mladý a do této pozice se člověk musí dopracovat."
                        ],
                        "hlasy": 34
                    },
                    {
                        "jmeno": "Pavel Hrubeš",
                        "cislo": 2,
                        "csa": true,
                        "info": [
                            "zklamání",
                            "Moje celá osobnost je založená na shitpostu a posílání koček.",
                            "Na internetu vystupuji pod pseudonymem Karel Hrubián, takže mi všichni říkaj Kája.",
                            "Mým velkým snem jsou samostatné Vratislavice nad Nisou.",
                            "Chci ukončit dlouholetou válku mezi Libercem a Jabloncem nad Nisou. Netuším jak, ale udělám to!"
                        ],
                        "hlasy": 37
                    },
                    {
                        "jmeno": "Veronika Kolomazníková",
                        "cislo": 3,
                        "csa": false,
                        "info": [
                            "Dozorčí orgán.",
                            "Okrádám chudé."
                        ],
                        "hlasy": 34
                    },
                    {
                        "jmeno": "David Kolomazník",
                        "cislo": 4,
                        "csa": false,
                        "info": [
                            "Podřízený dozorčímu orgánu.",
                            "Okrádám bohaté."
                        ],
                        "hlasy": 37
                    }
                ]
            }
        },
        "Praha": {
            "Magistrát Hlavního města Prahy": {
                "hlasy": 3474,
                "procenta": 0.01,
                "kandidati": [
                    {
                        "jmeno": "Lia Nova",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "sexy učitel satanismu",
                            "Volte trans muže, nebudou Vám kecat do interrupcí!",
                            "Mým hlavním bodem je pivo z kohoutku a druhotným férovější podmínky práce pro všechny. (A manželství pro všechny)"
                        ],
                        "hlasy": 1181
                    },
                    {
                        "jmeno": "Melisa Hujerová",
                        "cislo": 2,
                        "csa": true,
                        "info": [
                            "Volte mě, určitě je to lepší než nijak smysluplně využít svůj hlas!",
                            "Manažer protestů a aktivní povaleč",
                            "Instruktor lyžování a McDonald's",
                            "Nemám ráda lidi, miluju satiru a sushi"
                        ],
                        "hlasy": 1311
                    },
                    {
                        "jmeno": "Tomáš Vrla",
                        "cislo": 3,
                        "csa": false,
                        "info": [
                            "Ahoj. Jmenuji se Tomáš a už delší dobu žeru pastelky. V budoucnosti chci být profesionální požírač pastelek.",
                            "Enterprnaure + žádná p*áce + scrolluju na reels a mám 140+ IQ podle Mensa testu takže jsem génius prací",
                            "Zrušit creepery v Minecraftu (EU verze Minecraftu bude bez creeperů) a nastavit limit že jakmile máš míň než 25000 pohárků v Brawl Stars tak tě čeká eliminace"
                        ],
                        "hlasy": 952
                    }
                ]
            },
            "Praha 5": {
                "hlasy": 129,
                "procenta": 0.01,
                "kandidati": [
                    {
                        "jmeno": "Lia Nova",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "sexy učitel satanismu",
                            "Volte trans muže, nebudou Vám kecat do interrupcí!",
                            "Mým hlavním bodem je pivo z kohoutku a druhotným férovější podmínky práce pro všechny. (A manželství pro všechny)"
                        ],
                        "hlasy": 129
                    }
                ]
            },
            "Praha 15": {
                "hlasy": 47,
                "procenta": 0.01,
                "kandidati": [
                    {
                        "jmeno": "Tomáš Vrla",
                        "cislo": 1,
                        "csa": false,
                        "info": [
                            "Ahoj. Jmenuji se Tomáš a už delší dobu žeru pastelky. V budoucnosti chci být profesionální požírač pastelek.",
                            "Enterprnaure + žádná p*áce + scrolluju na reels a mám 140+ IQ podle Mensa testu takže jsem génius prací",
                            "Zrušit creepery v Minecraftu (EU verze Minecraftu bude bez creeperů) a nastavit limit že jakmile máš míň než 25000 pohárků v Brawl Stars tak tě čeká eliminace"
                        ],
                        "hlasy": 47
                    }
                ]
            },
            "Praha 18": {
                "hlasy": 47,
                "procenta": 0.03,
                "kandidati": [
                    {
                        "jmeno": "Melisa Hujerová",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "Volte mě, určitě je to lepší než nijak smysluplně využít svůj hlas!",
                            "Manažer protestů a aktivní povaleč",
                            "Instruktor lyžování a McDonald's",
                            "Nemám ráda lidi, miluju satiru a sushi"
                        ],
                        "hlasy": 47
                    }
                ]
            },
            "Praha Ďáblice": {
                "hlasy": 17,
                "procenta": 0.08,
                "kandidati": [
                    {
                        "jmeno": "Klára Lucie Soukupová",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "goonim nad vlakama",
                            "dělám tvojí mámu"
                        ],
                        "hlasy": 17
                    }
                ]
            }
        },
        "Středočeský": {
            "Benátky nad Jizerou-Na kandidátce Zelených": {
                "hlasy": 10047,
                "procenta": 19.07,
                "kandidati": [
                    {
                        "jmeno": "Tomáš Novák",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "kandiduje na kandidátce Zelených.",
                            "Jmenuji se Tomáš Novák, je mi 20 let a jsem skaut. Baví mě politika, ale i dělání si z ní legrace, proto jsem spoluzaložil Českou stranu asociálů. Nevěřím v existenci Brna, z tohoto důvodu jsem se rozhodl ho detailně prozkoumat z blízka. Jo a taky od září studuji na Masarykově univerzitě. Kandiduji, protože můžu, mám rád přírodu v Benátkách i okolí, chci přejmenovat všechny ulice na Cimrmanova (nebo alespoň jednu), Chci zamezit rozšiřování zelených migrantů! (invazivních rozstlin, které do našeho města nepatří), už mám pět bod? (toto Tom poslal Zeleným a ať to prej dám takhle na web)."
                        ],
                        "hlasy": 421,
                    }
                ]
            },
            "Bořanovice": {
                "hlasy": 18,
                "procenta": 0.97,
                "kandidati": [
                    {
                        "jmeno": "Štěpán Hanke",
                        "cislo": 1,
                        "csa": false,
                        "info": [
                            "kustod",
                            "Fanoušek Sparty a anarchie"
                        ],
                        "hlasy": 18
                    }
                ]
            },
            "Pětihosty": {
                "hlasy": 19,
                "procenta": 2.61,
                "kandidati": [
                    {
                        "jmeno": "Matěj Kadeřábek",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "Ahoj, já jsem Matěj, je mi 19 let a v Pětihostech žiju téměř celý svůj život. Studuju na ČVUT v Praze a zajímám se o dopravu, jídlo a efektivní mrhání časem. Do zastupitelstva kandiduji, protože si myslím, že i těch pár mladých lidí, co tu žije, by mělo mít možnost mluvit do toho, jak naše obec funguje, a taky proto, že jsem zjistil, že kandidovat do zastupitelstva je jednodušší než založit vlastní stát",
                            "autismus minmaxxing",
                            "|)O°|>/(O<' |)O#| :3"
                        ],
                        "hlasy": 19
                    }
                ]
            }
        },
        "Zlínský": {
            "Lukoveček": {
                "hlasy": 36,
                "procenta": 2.61,
                "kandidati": [
                    {
                        "jmeno": "Bc. Petr Juráň",
                        "cislo": 1,
                        "csa": true,
                        "info": [
                            "nevím, co tady má být"
                        ],
                        "hlasy": 20
                    },
                    {
                        "jmeno": "Pavel Juráň",
                        "cislo": 2,
                        "csa": false,
                        "info": [
                            "potencialní student"
                        ],
                        "hlasy": 16
                    }
                ]
            },
            "Slavičín": {
                "hlasy": 88,
                "procenta": 0.17,
                "kandidati": [
                    {
                        "jmeno": "Vítek Fojtík",
                        "cislo": 1,
                        "csa": false,
                        "info": [
                            "do školy nechodím a nezaměstnaný",
                            "Mé ambice jsou stát se slavičínským diktátorem. Mám rád fetování a sadismus. Nesnáším všechny děti, a moje politické oponenty."
                        ],
                        "hlasy": 88
                    }
                ]
            }
        }
    }
};

export const kandidatiSenatni = {

    2026: {},

    2025: {},

    2024: {  Karlovarský: {

            Sokolovsko: [

                { jmeno: "Nosorožec", csa: true }

            ]

        },

        Praha: {

            "Praha 2": [

                { jmeno: "DS Asociál", csa: true }

            ]

        },

        Liberecký: {

            Jablonecko: [

                { jmeno: "Mirek Kovář", csa: true }

            ]

        },

        Středočeský: {

            Benešovsko: [

                { jmeno: "Martines Cocoteros", csa: true }

            ],

            Mladoboleslavsko: [

                { jmeno: "Filip Slovan", csa: true }

            ]

        },

        Královéhradecky: {

            Náchodsko: [

                { jmeno: "Vykovikor", csa: true }

            ]

        },

        Olomoucký: {

            Prostějovsko: [

                { jmeno: "Jakuyeet", csa: true }

            ]

        },

        Moravskoslezský: {

            "Ostrava-město": [

                { jmeno: "Doslova Daniel Landa", csa: true }

            ],

            Opavsko: [

                { jmeno: "Bedřich Rakněff.", csa: true }

            ]

        },

        Ústecký: {

            Chomutovsko: [

                { jmeno: "Klement", csa: true }

            ],

            Teplicko: [

                { jmeno: "Erwin", csa: true }

            ]

        },

        Pardubický: {

            Chrudimsko: [

                { jmeno: "Stupid Cat", csa: true }

            ],

            Svitavsko: [

                { jmeno: "Konrád z ČSA", csa: true }

            ]

        },

        Zlínský: {

            Vsetínsko: [

                { jmeno: "MUDr. Štěpánka Kolářová", csa: true }

            ]

        }},

    2023: {},

    2022: { Královéhradecky: {

            Klodzko: [

                { jmeno: "Zdena Novotná", csa: true, info: "Ráda tráví 11 hodin denně pod kořenem" }

            ]

        },

        Liberecký: {

            Liberec: [

                { jmeno: "Adam Böhem", csa: true, info: "Kandidát do senátu" }

            ]

        }

    }



};



export const kandidatiKrajske = {

    2024: { Jihočeský: {

            Jihočeský: [

                { jmeno: "Parejnok", csa: true }

            ]

        },

        Jihomoravský: {

            Jihomoravský: [

                { jmeno: "Klement", csa: true }

            ]

        },

        Karlovarský: {

            Karlovarský: [

                { jmeno: "Dawes", csa: true, info: "Sportovní analytik, spolukandidát na hejtmana" },

                { jmeno: "merfistz", csa: true, info: "Ten o sobě nic nenapsal" },

                { jmeno: "NS Nosorožec", csa: true, info: "Ministr pravdy" }

            ]

        },

        Liberecký: {

            Liberecký: [

                { jmeno: "Kája", csa: true, info: "Pseudokoalice Asociální starostové pro Liberecký kraj" },

                { jmeno: "Konrád", csa: true, info: "Pseudokoalice Asociální starostové pro Liberecký kraj" },

                { jmeno: "Jan Farský", csa: true, info: "Pseudokoalice Asociální starostové pro Liberecký kraj" }

            ]

        },

        Moravskoslezský: {

            Moravskoslezský: [

                { jmeno: "Devastatom", csa: true }

            ]

        },

        Olomoucký: {

            Olomoucký: [

                { jmeno: "Jakuyeet", csa: true }

            ]

        },

        Pardubický: {

            Pardubický: [

                { jmeno: "Vojtý", csa: true }

            ]

        },

        Plzeňský: {

            Plzeňský: [

                { jmeno: "Mirda", csa: true }

            ]

        },

        Středočeský: {

            Středočeský: [

                { jmeno: "Filip Slovan", csa: true }

            ]

        },

        Ústecký: {

            Ústecký: [

                { jmeno: "Erwin", csa: true },

                { jmeno: "Balthazaar", csa: true, info: "Netuším, jestli se jmenoval jinak, už ani není na ČSA discordu" }

            ]

        },

        Vysočina: {

            Vysočina: [

                { jmeno: "Štěpánka Kolářová", csa: true }

            ]

        },

        Zlínský: {

            Zlínský: [

                { jmeno: "@iamnotdere", csa: true, info: "Netuším, jak se jmenoval/mu bylo přezdíváno" }

            ]

        }},

};



export const kandidatiEvropske = {

    2024: [

          { jmeno: "Karel Hrubián", cislo: 1, csa: true, info: ["místopředseda ČSA", "„Mými úhlavními nepřáteli jsou lidé, byrokracie a já sám.“"] },

        { jmeno: "Konrád Koulemastník", cislo: 2, csa: true, info: "předseda ČSA" },

        { jmeno: "Bruno Jan Sulc", cislo: 3, csa: true, info: "hudebník" },

        { jmeno: "Filip Slovan", cislo: 4, csa: true, info: "zakladatel právnické firmy Slovan-Stránský" },

        { jmeno: "Pavel Javůrek", cislo: 5, csa: true, info: "profesionální hráč Wild Raftu" },

        { jmeno: "Mirda Kovář", cislo: 6, csa: true, info: "student" },

        { jmeno: "Prti", cislo: 7, csa: true, info: "pomocník odpalů jaderných bomb" },

        { jmeno: "Stupid Cat", cislo: 8, csa: true, info: "ministr zahraničí" },

        { jmeno: "Lokan55", cislo: 9, csa: true, info: ["pastor církve Létajícího špagetového monstra", "„Evropský parlament potřebuje novou frakci, kde se budou sdružovat poslanci, kteří usilují o její zničení. ID k tomu nestačí.“"] },

        { jmeno: "Tomsek", cislo: 10, csa: true, info: "kavárenský povaleč" },

        { jmeno: "Sisina", cislo: 11, csa: true, info: "karlova kočka" },

        { jmeno: "NS Nosorožec", cislo: 12, csa: true, info: "profesionální jedlík" },

        { jmeno: "Klement Škoda von Klášterec", cislo: 13, csa: true, info: ["člen úřadu pro vývoj kočkoholek nebo podobná práce", "„EU nám nebude kecat do kočkoholek!“"] },

        { jmeno: "Šnek", cislo: 14, csa: true, info: "hlavní středoevropský výrobce diethylamidu kyseliny lysergrové" },

        { jmeno: "Odweg", cislo: 15, csa: true, info: "amatérský cimrmanolog" },

        { jmeno: "Doslova Daniel Landa", cislo: 16, csa: true, info: "čistic přenosných záchodů" },

        { jmeno: "Martin Psovy", cislo: 17, csa: true, info: "pokladač kabelů" },

        { jmeno: "Vykovikor", cislo: 18, csa: true, info: ["Neúspěšný řešitel geometrických úloh a student mezinárodních vztahů", "„Geometrie je jen nástroj státu k odkládání probírání politiky ve škole.“"] },

        { jmeno: "Ladislav Kotlík", cislo: 19, csa: false, info: "důchodce" },

        { jmeno: "pepa troska", cislo: 20, csa: true, info: "neúspěšný kandidát na prezidenta" },

        { jmeno: "Viktoriya Martinova Blakhova", cislo: 21, csa: true, info: ["extrémistická feministka", "„Jsem vinna, je-li vinna sestra má, mám účast ve všem, nesu s ní svůj díl.“"] },

        { jmeno: "Erwin", cislo: 22, csa: true, info: ["ministr poradenství", "„Komu není rady, tak mám padla.“"] }

    ],



};



export const kandidatiCelostatni = {

    2025: {

         Karlovarský: [

            {

                jmeno: "Nosorožec Mečiar",

                csa: true,

                info: [

                    "„Jedině Létající špagetové monstrum mě naučilo užívat pervitin.“",

                    "Nosorožcoslav „NS“ Mečiar je malý youtuber se zájmem o politiku, který kandiduje za ČSA v Karlovarském kraji. Též studuje gymnázium, zastává důležitou funkci na našem discordovém serveru (ministr pravdy) a svou budoucnost vidí velmi pozitivně, v mekáči.",

                    "Program:",

                    "pozdvihnout ČR v indexu korupce (konkurovat Jižnímu Sudánu)",

                    "zavést pastafariánskou ideologii ve školách",

                    "privatizace vzduchu"

                ]

            }

        ],

        Královec: [

            {

                jmeno: "Lůca Pribinová",

                csa: true,

                info: [

                    "„Dokud máš náboje, střílej. Když nemáš náboje, hoď pistoli.“",

                    "Lucie je studentkou gymnázia ve Vodňanech, která kandiduje v Královci. Miluje mývaly a kofein. Její důvod kandidatůry je prostý, nemá nic lepšího na práci. Jako každý náš kandidát má spousty nápadů, jak zlepšit tuto zem.",

                    "Program:",

                    "Chci jmenovat pribináček a seklihu národním jídlem.",

                    "Chci zakázat poštovní holuby, protože napsat dopis",

                    "poslat to po živým tvorovi je moc socializace.",

                    "Dětem bych dávala mobil co nejdřív, aby mohli vyrůst ve správné asociály, kteří budou zcela odtrženi od reality.",

                    "Zakázala bych matematiku a fyziku, protože mi to nejde- nechat si to vysvětlit je moc kontaktu s lidmi, a to podporovat nebudu.",

                    "Do veškeré pitné vody by se měl přidávat čistý kofein, aby se nemuselo čekat, než se ohřeje voda na kafe.",

                    "Každý politik by měl mít alespoň pět koček-pokud nezvládneš pět koček, nezvládneš stát. Prezidentský slib by se měl překládat do psí řeči.",

                    "Pan prezident by měl zaštěkat.",

                    "Zákaz konzumace nedostatečně osolených brambor."

                ]

            }

        ],

        Královéhradecký: [

            {

                jmeno: "Helmut Lörenz",

                csa: true,

                info: [

                    "„Na změnu není nikdy pozdě! Dokud není příliš pozdě...“",

                    "RNDr. Helmut Lörenz Ph.D je nejen člověk s fakt debilnim jménem, ale též pedagog, jaderný fyzik, spisovatel, Metalový kytarista, avšak hlavně náš kandidát v Královéhradeckém kraji. Je též specialistou na průmysl, školství, finance, vědu a kulturu.",

                    "Hlavní volební body:",

                    "zrušení společnosti",

                    "zodpovědná finanční politika",

                    "decentralizace"

                ]

            }

        ],

        Liberecký: [

            {

                jmeno: "Konrád Koulemastník",

                csa: true,

                info: [

                    "„Když nebudeš nikoho léčit s rakovinoudost dlouho, jednoho dne nebude mít rakovinu nikdo.“",

                    "Konrád Koulemastník je předseda ČSA, reinkarnace Létajícího špagetového monstra a budoucí nejvyšší vůdce galaxie, KTERÝ PROMĚNÍ VAŠE ŽIVOTY V DISTOPICKOU NOČNÍ MŮRU!!!. Taky má rád štrůdl.",

                    "Volební slib:",

                    "Donutí voliče SPD schovávat svůj ksicht v hidžábech."

                ]

            }

        ],

        "Mc Donaldovy Ostrovy": [

            {

                jmeno: "Ortvist Příjmení",

                csa: true,

                info: [

                    "„Ty nejlepší nápady přicházejí po termínu odevzdávání.“",

                    "„Mé jméno jest Ortvist a jsem světe div se biolog (ano vskutku se tím někdo živí) a kočkokluk! Vykonával jsem množství povolání, které mne předurčují k vedení naší nádherné vlasti, kupříkladu jsem byl moderátorem na minecraftovém serveru, taktéž jsem vykonával roli poradce ministra Dana! Mezi mé zájmy patří býti člověkem jako každý jiný (jsem jedním z Vás - muž lidu)“ Takto se popisuje náš kandidát za MC Donaldovy ostrovy.",

                    "Program:",

                    "Vyrovnaný rozpočet, nízké daně a vysoké důchody",

                    "Vyhrát každé MS v hokeji, i kdyby to znamenalo vojenskou intervenci do pořadatelské země",

                    "Kočičí ouška do každé rodiny",

                    "Uzavření jižní hranice (ta s Maďarskem)",

                    "Rovnost pro všechny (pro mne trochu víc)"

                ]

            }

        ],

        Sibiř: [

            {

                jmeno: "Georgius Amadeus",

                csa: true,

                info: [

                    "„Vrátíme Sibiř Čechům! Nebo tak něco...“",

                    "Georgius Amadeus je studentem, který je odborníkem na úplně vše, prodává vše a též vlastní zubaté žáby. Kandiduje v autonomním regionu Siberia -1.",

                    "Vize:",

                    "Dobude Russkou Sibiř (právoplatné území z roku 1920)",

                    "Zavede záporné daně z příjmů FO nad 300 mil. KČ",

                    "Obnoví právní institut postrku",

                    "Zavede jednotku policie na likvidaci habsburského dědictví",

                    "Zvýší počet úředníků o 30 % a sníží jejich efektivitu o 90 %."

                ]

            }

        ],

        Středočeský: [

            {

                jmeno: "Filip Slovan",

                csa: true,

                info: [

                    "„Každý hlas se počítá“ Kromě těch neplatných… Nebo ty se taky počítaj, jen neplatěj....“",

                    "Filip Slovan, druhý místopředseda strany, kandiduje ve Středočeském kraji. Je to nerd- takový všeználek, co má ke všemu poznámku- cimrmanolog, tvůrce memů a byrokrat v praxi, takže je nenáviděn mezi anarchokapitalisty.",

                    "Program:",

                    "Bude to první poslanec, co vysadí brambor.",

                    "Převede hlasování sněmovny do Kahootu.",

                    "Státní dluh dám na ruletu",

                    "Snížím věk být volen na 18 let a volit od 16-ti",

                    "Hlas lidu bude konečně ve sněmovně slyšet!! (otevřu okno)"

                ]

            },

            {

                jmeno: "Štěpánka Kolářová",

                csa: true,

                info: [

                    "„Každý den je příležitost obdivovat Šotovníka molokaiského.“",

                    "Štěpánka Kolářová je amatérská přírodovědkyně, majitelka ZOO pro Theriány na Kmochově ostrově, ale hlavně je druhou kandidátkou ve Středočeském kraji. Na discordovém serveru ČSA zastává funkci ministryně života.",

                    "Program:",

                    "Federace s Estonskem",

                    "Zavedení pomalíků, jako alternativy k rychlíkům",

                    "Vrátit sušenky Vlnky do prodeje",

                    "Povinnost nejvyšších představitelů státu zveřejňovat každý týden svůj nákupní seznam"

                ]

            }

        ],

        Švýcarsko: [

            {

                jmeno: "Vojtěch Konrádofil Asociál",

                csa: true,

                info: [

                    "„Lepší femboy doma než žena kdekoli.“",

                    "Vojta Konrádofil Asociál je kandidátem ve Švýcarsku… Ne, tohle není překlep, fakt tam kandiduje. Nejlepší bude, když se Vám představí sám… Dobrý den, jmenuji se Vojtěch Konrádofil Asociál a ve skutečnosti jsem vlastně kočička. Mám rád femboye, internet a Viktora. Viděl jsem všechny díly prostřena, kde byl Konrád. Hraju na klavír a umím zahrát Eriku nazpaměť. Dejte mi hlas plsky uwu^-^",

                    "Program:",

                    "Zavede free WiFi na náměstích, protože to maj Düsseldorfu a je to mega OP.",

                    "Příděl pervitinu pro každého.",

                    "Vyvraždí celou opozici, aby ho nemohla kritizovat.",

                    "Novám společenským oblekem budou kočičí ouška."

                ]

            }

        ],

        Ústecký: [

            {

                jmeno: "Tomáš Sergej Neumann",

                csa: true,

                info: [

                    "„Moč je uložena v koulích.“",

                    "Tomáš Sergej Neumann je #1 nenávideč Slováků, který vystudoval vojenskou školu, jelikož ho na umělku nevzali. Kandiduje, aby navrátil Rusko-Německou národní hrdost.",

                    "Nápady:",

                    "Odsune Slováky z našeho území.",

                    "Anektuje Bratislavský kraj",

                    "Zbytek Slovenska přemístí a místo něj vznikne Tatranské moře",

                    "K ČR připojí Královec a Východní Německo",

                    "Zakáže spisovnou češtinu",

                    "Od jeho zvolení se bude mluvit pouze nářečím",

                    "Reformy:",

                    "Sněmovna podle pivního kvocientu – hlasy poslanců budou váženy podle počtu vypitých piv během rozpravy. Více piv = silnější hlas. Střízliví poslanci mají pouze poradní hlas.",

                    "Kulturní obroda a mediální očista – Česká televize bude povinně vysílat jen věci, co mají smysl – tedy večerníček, retro seriály a rybářské pořady. Zavedeme veřejné čtení z příbalových letáků – protože i to je literatura.",

                    "Důchodová reforma – Důchodci budou pracovat, abychom se my mladí mohli flákat a nechodit z domu!"

                ]

            }

        ],

        "Země Moravské": [

            {

                jmeno: "Klement",

                csa: true,

                info: [

                    "„Zaprvé nevím a zadruhé mi to je jedno.“",

                    "Klement je velice aktivní hoch. Ve svých patnácti letech se snaží o osamostatnění Moravy, spravuje 3D tiskárnu pro školu a též má obchod s plackami. Má vystudovanou švejkologii, tudíž je velmi vzdělaný. Jeho největší úspěch je však jeho instagramový účet Save Moravia, který spravuje on sám. Kandiduje v Zemi Moravské (pozn. Přelepit Jihomoravský kraj na zem Moravskou).",

                    "Program:",

                    "Zakážu existenci hlavního města Prahy",

                    "Posmrtně odeberu titul kněžny paní Libuši",

                    "Zajdu si koupit něco k pití",

                    "Koupím všem hasičům zapalovač",

                    "Pošlu invalidy na vozíčku sedět (na vozíčku)",

                    "Pokud nebude pozdě tak uhasím Ležáky",

                    "Otevřu na hradě Houska pekařství s rohlíky",

                    "Prosadím Českomoravského griffina jako logo ČR (neptejte se jak vznikl)",

                    "Spojím Moravské a Rumunské Valašsko (Pakt Bolek-Drákula)",

                    "Přejmenuji Zlín na Klementov",

                    "Donutím femboye nosit kroje",

                    "Zvýším daně pravičákům a snížím je levičákům",

                    "Přesunu Bavorov tam kde jsou Vodňany",

                    "Navážu na slovenský převrat Bolka Polívky",

                    "Vysadím řepu do nepoužívaných řopíků... teda teď už řepíků",

                    "Donutím lesní zvěř dávat přednost zprava",

                    "Zavedu gotické dívky do gotických památek jako průvodkyně",

                    "Domluvím Spartě zápas proti starověkým Aténám",

                    "Změním národnost Víta Rakušana aby odpovídala jeho Nachname",

                    "Uchráním tradiční hodnoty (myšleno čísla v oboru reálných čísel)",

                    "Dám heslo ústeckému UJEP které zní: \"co můžeš\"",

                    "Hrdý Budžes dostane Řád budování socialistické vlasti",

                    "Otevřu druhou přepážku na migračním úřadě, aby se přestala rozšiřovat ukrajinská fronta",

                    "Policie a Hasiči budou cvičit v Roblox ER:LC"

                ]

            }

        ]

    }

};
